var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hub-update" }, [
    _vm.items && _vm.items.length
      ? _c(
          "div",
          [
            _c("TitleBlock", {
              attrs: { text: _vm.titleText, link: _vm.searchLink },
            }),
            _vm._v(" "),
            _vm._l(_vm.items, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "row" },
                [
                  _c("Update", {
                    class: {
                      "hub-informative-update":
                        item.classification === "Informative",
                      "hub-indicative-update":
                        item.classification === "Indicative",
                      "hub-actionable-update":
                        item.classification === "Actionable",
                    },
                    attrs: {
                      date: item.publishDate ? item.publishDate : null,
                      title: item.title,
                      link: item.url,
                      "has-access": _vm.hasAccess,
                    },
                  }),
                ],
                1
              )
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }